<script>
  import Vue from 'vue'
  import { base64Decode } from '@dcb/utils'
  import { router } from '@/router'

  export default Vue.extend({
    created() {
      let { url } = router.currentRoute.query
      url = decodeURIComponent(url)
      url = base64Decode(url)
      location.href = url
    },

    render() {
      return null
    },
  })
</script>
